module.exports = __webpack_public_path__ + "img/9D.9ed9303d.png";